module.exports = __webpack_public_path__ + "media/images/nav-logo-nuvola-bf60f0d6933eae66c4bba497c6a36be2.png";